import React, { useContext, useEffect, useState } from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import HomeViewTecnico from "../../Styles/layout/homeViewTecnico";
import { CustomTextField, CustomTextFieldPass, CustomTextFieldPass_atual, CustomTextFieldPassConfirm, CustomThemeProvider } from "../../Styles/theme/customThemeprovider";
import { IconButton, InputAdornment, Snackbar } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { BarraDeFerramentas } from "../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { verifica_se_tem_pelo_menos_um_carater_especial } from "../../Func_genericas/verifica_se_tem_pelo_menos_um_carater_especial";
import { func_print } from "../../Func_genericas/func_print";
import { post_login } from "../../Services/tokenConfig";
import { AuthContext } from "../../AuthContext/AuthContext";
import LoadingVulpes from "../../Styles/Loader/loading";
import { Alert } from "../../Components/Alert/Alert";
import { cores } from "../../Func_genericas/valores_estaticos";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(2),
    },
    label: {
      display: "flex",
      flexWrap: "wrap",
      "& > *": {
        // margin: theme.spacing(1),
        // width: theme.spacing(16),
        // height: theme.spacing(16),
        // minWidth: 325,
      },
    },
    header: {
      textAlign: "center",
      background: "#FAFAFA",
      color: "#7e2706",
    },
    picker: {
      color: "#7e2706",
      "&.Mui-checked": {
        color: "#ccafa3",
      },
    },
    tabs: {
      "& .MuiTabs-indicator": {
        backgroundColor: cores.cor1,
        height: 3,
      },
      "& .MuiTab-root.Mui-selected": {
        color: cores.cor1,
      },
    },
  })
);

export default function DefinicoesTecnico() {
  const classes = useStyles();
  const auth = useContext(AuthContext);

  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const [error_nome, set_error_nome] = useState<boolean>(false);
  const [checkPass, setCheckPass] = useState<boolean>(false);

  const [mostrar_passe, set_mostrar_passe] = useState<boolean>(false)
  const [mostrar_passe1, set_mostrar_passe1] = useState<boolean>(false)
  const [mostrar_passe2, set_mostrar_passe2] = useState<boolean>(false)

  const [nome, set_nome] = useState<string | undefined>()
  const [password, set_password] = useState<string | undefined>()
  const [password_confirmacao, set_password_confirmacao] = useState<string | undefined>()
  const [password_atual, set_password_atual] = useState<string | undefined>()


  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);

  const [message, setMessage] = useState("");



  const handleClick = async () => {

    let flag_valido_nome = false
    let flag_valido_pass = false

    if (nome === undefined || nome.length === 0) {
      set_error_nome(true)
      flag_valido_nome = false

    } else {
      set_error_nome(false)
      flag_valido_nome = true
    }

    if (password !== undefined && password_confirmacao !== undefined) {

      if (!verifica_se_tem_pelo_menos_um_carater_especial(password) || !verifica_se_tem_pelo_menos_um_carater_especial(password_confirmacao) || password?.length < 8 || password_confirmacao?.length < 8 || password_confirmacao !== password) {
        setCheckPass(true)
        flag_valido_pass = false

      } else {
        setCheckPass(false)
        flag_valido_pass = true

      }
    } else {
      flag_valido_pass = true

    }

    if (flag_valido_nome && flag_valido_pass) {
      setIsLoading(true)
      try {


        let result = await post_login(auth.token.cookie_token, `/reset_user`, {
          payload: {
            email: auth.user?.email,
            password: password !== undefined ? password : null,
            antiga_password: password_atual !== undefined ? password_atual : null,
            nome: nome

          }
        })

        func_print('result', result)

        if (result.status === 200) {
          setOpenSnackSuccess(true)
          setMessage('A sua operação realizada com sucesso!');

        } else {
          setMessage("Erro ao realizar a sua operação!");
          setOpenSnackError(true);
        }



        setIsLoading(false)




      } catch (error) {
        func_print('get_info', error, true)
        setIsLoading(false)
        setMessage("Erro ao realizar a sua operação!");
        setOpenSnackError(true);

      }
    }


  };



  const handleCloseSnack = () => {
    setOpenSnackSuccess(false);
    setOpenSnackError(false);
  };


  return (
    <CustomThemeProvider>

      <div className={classes.root}>
        <HomeViewTecnico title="Definições" />
        <main className={classes.contents}>
          <div className={classes.toolbars} />

            <Snackbar
              open={openSnackSuccess}
              autoHideDuration={2000}
              onClose={handleCloseSnack}
            >
              <Alert
                onClose={handleCloseSnack}
                severity="success"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
            <Snackbar
              open={openSnackError}
              autoHideDuration={2000}
              onClose={handleCloseSnack}
            >
              <Alert
                onClose={handleCloseSnack}
                severity="error"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
            {
              isLoading === true ?
                <LoadingVulpes></LoadingVulpes> :

                <div style={{
                  flex: 1,
                  alignSelf: 'center',
                  justifySelf: 'center',

                  alignItems: "center",
                  justifyContent: 'center',
                  flexDirection: 'column',
                  display: "flex",
                  width: '50%',
                  paddingTop: '15%',
                  height: '50%',


                }}>
                  <CustomTextField
                 
                    error={error_nome}
                    helperText={error_nome === true ? 'Preenchimento do nome obrigatório' : ''}
                    fullWidth
                    name="nome"
                    type="nome"
                    label="Nome Completo"
                    placeholder="Nome Completo"
                    margin="normal"
                    value={nome}
                    onChange={(e: any) => set_nome(e.target.value)}
                  />
                  <CustomTextFieldPass_atual

                    error={checkPass}
                    selectBool={checkPass}
                    label="Palavra-Passe Atual"
                    //helperText={checkPass === true ? 'Palavra-Passe inválida' : ''}
                    value={password_atual}
                    onChange={(e: any) => set_password_atual(e.target.value)}

                    placeholder="Palavra-Passe Atual"

                    type={mostrar_passe ? 'text' : 'password'}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => { set_mostrar_passe(!mostrar_passe) }}

                          edge="end"
                        >
                          {mostrar_passe ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  <CustomTextFieldPass

                    error={checkPass}
                    selectBool={checkPass}
                    label="Nova Palavra-Passe"
                    //helperText={checkPass === true ? 'Palavra-Passe inválida' : ''}
                    value={password}
                    onChange={(e: any) => set_password(e.target.value)}

                    placeholder="Nova Palavra-Passe"

                    type={mostrar_passe1 ? 'text' : 'password'}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => { set_mostrar_passe1(!mostrar_passe1) }}

                          edge="end"
                        >
                          {mostrar_passe1 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  <CustomTextFieldPassConfirm
                    error={checkPass}
                    selectBool={checkPass}

                    label="Confirmação da Nova Palavra-Passe"
                    // helperText={checkPass === true ? 'Palavra-Passe inválida' : ''}
                    value={password_confirmacao}
                    onChange={(e: any) => set_password_confirmacao(e.target.value)}

                    placeholder="Confirme a palavra-passe"

                    type={mostrar_passe2 ? 'text' : 'password'}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          // aria-label="toggle password visibility"
                          onClick={() => { set_mostrar_passe2(!mostrar_passe2) }}

                          edge="end"
                        >
                          {mostrar_passe2 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }

                  />
                  <div style={{
                    paddingTop: '4%',
                    width: '100%',
                    alignItems: "flex-end",
                    justifyContent: 'flex-end',
                    display: "flex",
                  }}>
                    <BarraDeFerramentas
                      mostrarBotaoGravar
                      aoClicarGravar={() => handleClick()}
                    />
                  </div>

                </div>

            }


        </main>
      </div>
    </CustomThemeProvider>

  );
}

